import React from 'react'
import { DetailsViewWrapper, HeaderContent } from '../general'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { OStromSvg } from '../../resources'
import { FooterContent } from './helpers'
import { ExtensionTypes, ExtensionDetailsProps } from '../../types'
import { extensionColors } from '../../colors'
import { useTheme } from '@mui/material'
import { isFlowTheme } from 'src/Libs/utils/theme-helpers'

/**
 * Gives a detailed description of the ostrom marketing extension.
 */
const OStromDetails: React.FC<ExtensionDetailsProps> = ({ extensionState, hasActiveTariff, onClose, place = 0, isLoading }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const contractStateProps = {
    contractState: extensionState,
    isLoading,
  }
  const description1 = isFlowTheme
    ? t('installation-extensions.o-strom.details.description.flow')
    : t('installation-extensions.o-strom.details.description')
  const description2 = isFlowTheme
    ? t('installation-extensions.o-strom.details.description2.flow')
    : t('installation-extensions.o-strom.details.description2')

  return (
    <DetailsViewWrapper
      extensionType={ExtensionTypes.OStrom}
      descriptions={[description1, description2]}
      headerContent={<HeaderContent logo={<OStromSvg textFill={extensionColors[ExtensionTypes.OStrom].primary} />} />}
      footerContent={<FooterContent extensionState={extensionState} hasActiveTariff={hasActiveTariff} />}
      onClose={onClose}
      place={place}
      open={true}
      category={{ name: 'dynamic-energy-tariff', paletteColor: theme.palette.secondary }}
      contractStateProps={contractStateProps}
    />
  )
}

export default OStromDetails
